// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import Countdown from '../../../../components/Countdown';
import useMergeProps from '../../../../hooks/useMergeProps';
import {
  selectBoomGlobalOperationEndDate,
  selectBoomGlobalOperationStartDate,
} from '../../selectors/global/globalPrimary.selector';

type BoomBannerCountdownContainerProps = {
  className?: string;
};

const BoomBannerCountdownContainer = (ownProps: BoomBannerCountdownContainerProps) => {
  const operationEndDate = useSelector(selectBoomGlobalOperationEndDate);
  const operationStartDate = useSelector(selectBoomGlobalOperationStartDate);

  const selectedProps = useMemo(
    () => ({
      startDate: operationStartDate,
      endDate: operationEndDate,
    }),
    [operationEndDate, operationStartDate],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });
  return <Countdown {...enhancedProps} />;
};

export default BoomBannerCountdownContainer;
